(function () {
  function syncAccordionStatsWidth() {
    document.querySelectorAll('.byarums-accordion').forEach(function (accordion) {
      var statsBlocks = accordion.querySelectorAll('.byarums-accordion__stats');
      if (!statsBlocks.length) return;

      if (window.matchMedia('(max-width: 1199px)').matches) {
        accordion.style.removeProperty('--accordion-stats-width');
        return;
      }

      var maxWidth = 0;

      statsBlocks.forEach(function (block) {
        block.style.width = 'max-content';
      });

      statsBlocks.forEach(function (block) {
        maxWidth = Math.max(maxWidth, block.getBoundingClientRect().width);
      });

      statsBlocks.forEach(function (block) {
        block.style.width = '';
      });

      if (maxWidth > 0) {
        accordion.style.setProperty('--accordion-stats-width', Math.ceil(maxWidth) + 'px');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAccordionStatsWidth);
  } else {
    syncAccordionStatsWidth();
  }

  window.addEventListener('resize', syncAccordionStatsWidth);
  document.addEventListener('shopify:section:load', syncAccordionStatsWidth);
  document.addEventListener('shopify:block:select', syncAccordionStatsWidth);
})();
